import styled from "styled-components";
import { withViewState } from "../Context";
import { jsx as _jsx } from "react/jsx-runtime";
const ControlsWrapper = styled.div.withConfig({
  displayName: "ExperimentalFeatures__ControlsWrapper",
  componentId: "sc-1mw9shz-0"
})(["position:absolute;left:25px;bottom:25px;z-index:1;@media (min-width:", "px){top:auto;bottom:100px;}"], props => props.theme.sm);
const Control = styled.div.withConfig({
  displayName: "ExperimentalFeatures__Control",
  componentId: "sc-1mw9shz-1"
})(["margin:15px 0;text-align:center;&:last-child{margin-bottom:0;}"]);
const ExperimentalFeatures = props => {
  return /*#__PURE__*/_jsx(ControlsWrapper, {
    children: (props.experimentalItems || []).map((item, i) => /*#__PURE__*/_jsx(Control, {
      children: item
    }, i))
  });
};
export default withViewState(ExperimentalFeatures);